export function validateEmail(email: string) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
    }
    return false;
}

export function panCardValidation(panNumber: string): boolean {
    let regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (regex.test(panNumber)) {
        return true;
    } else {
        return false;
    }
};

export function validateGST(GST: string): boolean {
    var expr = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!expr.test(GST)) {
        return false;
    }
    return true;
}

export function removeEmptyValues(value: any): any {
  if (Array.isArray(value)) {
    const cleanedArray = value
      .map(removeEmptyValues)
      .filter(v => v !== undefined && (typeof v === 'boolean' || v));

    return cleanedArray.length > 0 ? cleanedArray : undefined;
  }

  if (typeof value === 'object' && value !== null) {
    const newObj: Record<string, any> = {};

    for (const key in value) {
      const cleaned = removeEmptyValues(value[key]);

      if (cleaned !== undefined && (typeof cleaned === 'boolean' || cleaned)) {
        newObj[key] = cleaned;
      }
    }

    return Object.keys(newObj).length > 0 ? newObj : undefined;
  }

  // Keep booleans, numbers (including 0), and non-empty strings
  if (
    typeof value === 'boolean' ||
    typeof value === 'number' ||
    (typeof value === 'string' && value.trim() !== '')
  ) {
    return value;
  }

  return undefined;
}

export function convertTaxPercentageToTaxArray(taxPercentage: number | undefined) {
  if (!taxPercentage) return undefined;
  
  return [
    {
      type: "CGST",
      condition: {
        basedOn: "State",
        is: "Same",
      },
      percentage: taxPercentage / 2,
    },
    {
      type: "SGST",
      condition: {
        basedOn: "State",
        is: "Same",
      },
      percentage: taxPercentage / 2,
    },
    {
      type: "IGST",
      condition: {
        basedOn: "State",
        is: "Different",
      },
      percentage: taxPercentage,
    },
  ];
}

